import { useContext, useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

// import UserProfile from '../User/UserProfile';
// import Logo from '../../assets/branding/logo.svg'
import Logo from '../../assets/branding/logo-white.png';
// import Map from '../../assets/icons/map.svg'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMap, faUser } from '@fortawesome/free-regular-svg-icons';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

import UserContext from '../../store/user-context';

const Navigation = () => {
  const historyLocation = useLocation();
  const [showLandingLink, setShowLandingLink] = useState(false);
  const [showTownMap, setShowTownMap] = useState(true);
  const [landingLink, setLandingLink] = useState('');
  const userContext = useContext(UserContext);
  const [showNav, setShowNav] = useState(true);
  const dispatch = useDispatch();
  let conversationData = useSelector((state) => state.conversationData);

  const resetLesson = () => {
    dispatch({
      type: 'resetCurrentLesson'
    })
  }

  useEffect(() => {
    if (historyLocation.pathname.includes('unsubscribe')) {
      setShowNav(false);
    } else {
      if (historyLocation.pathname === '/') {
        setShowTownMap(false);
      } else {
        setShowTownMap(true);
      }

      if (
        Object.prototype.hasOwnProperty.call(userContext, 'showLandingLink')
      ) {
        if (
          historyLocation.pathname.includes('/conversation/') &&
          userContext.user.showLandingLink === true
        ) {
          setLandingLink(
            `/conversation/${historyLocation.pathname.split('/')[2]}`,
          );
          setShowLandingLink(true);
        } else {
          setShowLandingLink(false);
        }
      }
    }
  }, [historyLocation]);

  useEffect(() => {
    if (historyLocation.pathname.includes('/conversation/') && Object.keys(conversationData).length > 0) {
      setLandingLink(
        `/conversation/${historyLocation.pathname.split('/')[2]}`,
      );
      setShowLandingLink(true);
    } else {
      setShowLandingLink(false);
    }
  }, [userContext, conversationData]);

  return showNav ? (
    <>
      <div className="navigation">
        <img src={Logo} alt="golingo" title="golingo" id="logo" />
        <div className="user-actions">
          {showLandingLink && (
            <Link to={landingLink} onClick={resetLesson} className="navigation__icons town-map">
              <FontAwesomeIcon icon={faArrowLeft} size="1x" />
            </Link>
          )}
          {showTownMap && (
            <Link to="/" className="navigation__icons town-map">
              <FontAwesomeIcon icon={faMap} size="1x" />
            </Link>
          )}
          <Link to="/user/dashboard" className="navigation__icons user-avatar">
            <FontAwesomeIcon icon={faUser} size="1x" />
          </Link>
        </div>
      </div>
    </>
  ) : null;
};

export default Navigation;
